import { render, staticRenderFns } from "./BuildDeck.vue?vue&type=template&id=6f35a61a&scoped=true&"
import script from "./BuildDeck.vue?vue&type=script&lang=js&"
export * from "./BuildDeck.vue?vue&type=script&lang=js&"
import style0 from "./BuildDeck.vue?vue&type=style&index=0&id=6f35a61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f35a61a",
  null
  
)

export default component.exports